export default __webpack_public_path__ + "static/media/document.9e6f31c6.svg";